import React from 'react';
import styled from 'styled-components';
import { Box } from '@material-ui/core';
import color from 'config/color';

export const BannerContainer = styled(Box)`
  padding: 30px;
  font-size: 20px;
  line-height: 1px;
  background-image: linear-gradient(#1c2e3d, #263e51, #34516a);

  @media (max-width: 600px) {
    padding-left: 1em;
  }
`;

export const PresentPage = styled.div`
  margin-left: 12%;
  height: auto;
  width: fit-content;
  margin-right: 0;

  @media (max-width: 600px) {
    margin: 0;
  }
`;

export const Title = styled.h3`
  font-size: 27px;
  color: ${props => props.color || 'white'};
  font-weight: bold;
`;

export const SubTitle = styled.h1`
  margin-top: 11px;
  color: ${color.lightGrey};
  font-size: 17px;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

export default function HeaderBanner({ title, subtitle, children }) {
  return (
    <BannerContainer>
      <PresentPage>
        <Row>
          <div style={{ width: 'fit-content' }}>
            <Title> {title} </Title>
            <SubTitle>{subtitle} </SubTitle>
          </div>
          {!children ? null : (
            <div>
              <h4
                style={{
                  color: 'white',
                  marginLeft: '25em',
                  marginRight: '0',
                  lineHeight: 3
                }}
              >
                {children}
              </h4>
            </div>
          )}
        </Row>
      </PresentPage>
    </BannerContainer>
  );
}
